<template>
  <div :class="divClass">
    <label :for="forLabel" :class="labelClass">{{ label }}</label>
    <select
      :id="idSelect"
      :class="selectClass"
      :disabled="disabled"
      :required="required"
    >
      <option :value="valueDefault" disabled>{{ optionDefault }}</option>
      <option v-if="items.length > 0" v-for="(item, i) in items" :value="item.name" :key="i">{{ item.value }}</option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    divClass: String,
    forLabel: String,
    labelClass: String,
    label: String,
    nameSelect: String,
    idSelect: String,
    selectClass: String,
    required: Boolean,
    disabled: Boolean,
    valueModel: String,
    valueDefault: String,
    optionDefault: String,
    items: Array,
  },
};
</script>
